import api from "./api";

export default class ProductAPI {
    static getProducts = async (page: number, recordsPerPage: number, search: string) => {
        const response = await api.get(`/Produto?Page=${page}&RecordsPerPage=${recordsPerPage}&Search=${search}`);
        return response.data;
    };
    static getProductById = async (id: number) => {
        const response = await api.get(`/Produto/${id}`);
        return response.data;
    };
};